export class Seller {
  public company: string;
  public sellerId: string;
  public resellerId: string;
  public isReseller: boolean;
  public name: string;
  public aktiaId: string;
  public veritasId: string;
  public team: string;
  public deleted: boolean;

  static createFromResponse(data: any): Seller {
    var seller = new Seller();
    seller.company = data["company"];
    seller.sellerId = data["sellerId"];
    seller.resellerId = data["resellerId"];
    seller.isReseller = data["reseller"];
    seller.name = data["name"];
    seller.aktiaId = data["aktiaid"];
    seller.veritasId = data["veritasid"];
    seller.team = data["teamName"];
    seller.deleted = data["deleted"];
    return seller;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-sellers/Seller.ts